import React, { FC, useMemo } from "react";
import "./Classifiers.scss";
import useCollapsable from "../../../common/utilities/hooks/useCollapsable";
import CategorizationSwitch from "./categorizationSwitch/CategorizationSwitch";
import { useConfigMapCategorizations } from "../../../configMap/hooks/useConfigMapCategorizations";
import { useGroupBlockCategorizations } from "../../../configMap/hooks/useGroupBlockCategorizations";

type Props = {
  disabled: boolean;
  groupBlockId?: string;
  index?: number;
  showHeader: boolean;
};

const CategorizationBlock: FC<Props> = ({
  disabled,
  showHeader,
  groupBlockId,
  index = 1,
}) => {
  const { handleClick, style, open } = useCollapsable();

  const { categorizationLinks: configMapLinks } = useConfigMapCategorizations();
  const { categorizationLinks: groupBlockLinks } =
    useGroupBlockCategorizations(groupBlockId);

  const categorizationsWithConfig = useMemo(() => {
    return groupBlockId ? groupBlockLinks : configMapLinks;
  }, [groupBlockId, groupBlockLinks, configMapLinks]);

  if (!categorizationsWithConfig?.length) {
    return null;
  }

  return (
    <div className="classifier-block__container">
      {showHeader ? (
        <div
          className="classifier-block__header"
          style={open ? { marginBottom: "20px" } : { marginBottom: 0 }}
        >
          <h1>Categorization values</h1>
          {open ? (
            <i className="bi bi-arrow-up-circle" onClick={handleClick} />
          ) : (
            <i className="bi bi-arrow-down-circle" onClick={handleClick} />
          )}
        </div>
      ) : null}
      <div
        className={`classifier-block__items ${open ? "open" : ""}`.trim()}
        style={style}
      >
        {categorizationsWithConfig.map((categorizationWithConfig) => (
          <CategorizationSwitch
            key={categorizationWithConfig.categorization.id}
            disabled={disabled}
            categorizationWithConfig={categorizationWithConfig}
            groupBlockId={groupBlockId}
            index={index}
          />
        ))}
      </div>
    </div>
  );
};

export default CategorizationBlock;
